import Repository from '@/repositories/marketing'
const resource = '/relational_tables'

export default {
    create(config){
        return Repository.post(`${resource}.json`, config)
    },
    update(id,config){
        return Repository.put(`${resource}/${id}.json`, config)
    },
    getLists(config){
        return Repository.get(`${resource}.json`, config)
    },
    getTable(id, config){
        return Repository.get(`${resource}/${id}.json`, config)
    },
    bulkRefresh(config){
        return Repository.post(`${resource}/bulk_refresh.json`, config)
    },
    refresh(id, config){
        return Repository.get(`${resource}/${id}/refresh_count.json`, config)
    },
    truncate(id, config){
        return Repository.get(`${resource}/${id}/truncate.json`, config)
    },
    import(id, config){
        return Repository.post(`${resource}/${id}/import.json`, config)
    },
    export(id, config){
        return Repository.post(`${resource}/${id}/export.json`, config)
    },
    delete(id){
        return Repository.delete(`${resource}/${id}.json`)
    },
    fetchRelationships(id, config){
        return Repository.get(`${resource}/${id}/table_relationships.json`, config)
    },
    deleteRelationship(id, relation_id, config){
        return Repository.delete(`${resource}/${id}/table_relationships/${relation_id}.json`, config) 
    },
    getToTables(id, config){
        return Repository.get(`${resource}/${id}/reference_tables.json`, config)
    },
    getToColumns(id, config){
        return Repository.get(`${resource}/${id}/columns.json`, config)
    },
    createRelationship(id, payload, config){
        return Repository.post(`${resource}/${id}/table_relationships.json`, payload, config)
    },
    updateRelationship(table_id, id, payload, config){
        return Repository.put(`${resource}/${table_id}/table_relationships/${id}.json`, payload, config)
    },
    bulkDelete(config){
        return Repository.delete(`${resource}/bulk_delete.json`, config)
    },
    getColumnsList(id, config){
        return Repository.get(`${resource}/${id}`, config)
    },
    checkColumnRelationship(id, config){
        return Repository.get(`${resource}/${id}/check_column_relationship_status.json`, config)
    },
    getRecords (id, config) {
        return Repository.get(`${resource}/${id}/get_records.json`, config)
    },
    createRecord (id, payload, config) {
        return Repository.post(`${resource}/${id}/new_record.json`, payload, config)
    },
    updateRecord (id, payload, config) {
        return Repository.put(`${resource}/${id}/update_record.json`, payload, config)
    },
    deleteRecord (id, config) {
        return Repository.delete(`${resource}/${id}/delete_record.json`, config)
    },
    findUid(tableId,config){
        return Repository.get(`${resource}/${tableId}/validate_uid.json`, config)
    }
}